
import './styles.css';
import { useHistory } from "react-router-dom";

function Production() {

    const history = useHistory();

    return (
        <div className='content'>

            <div className="content-menu">
                <div className="box-menu" onClick={() => history.push({ pathname: "/d-rec-admin/main/production/result-pd" })}>
                    <div className="content" style={{ backgroundColor: "rgb(242, 123, 129)" }}>
                        <div className="shot-name">RPD</div>
                        <div className="full-name">Result CheckSheet</div>
                        <div className="line"></div>
                        <div className="note">Looking result CheckSheet of Production</div>
                    </div>
                </div>
                <div className="box-menu" onClick={() => history.push({ pathname: "/d-rec-admin/main/production/checksheet" })}>
                    <div className="content" style={{ backgroundColor: "rgb(255, 192, 168)" }}>
                        <div className="shot-name">CSM</div>
                        <div className="full-name">CheckSheet Management</div>
                        <div className="line"></div>
                        <div className="note">Management all about CheckSheet PD.</div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default Production;